module.exports = __webpack_public_path__ + "img/home_icon_police_logo@3x.11be78be.png";